export default function PaymentSuccess() {
  return (
    <>
      <div className="screen active" id="screen-success">
        <div className="page-head">
          <div>
            <h1>Payment batch complete</h1>
            <div className="ph-sub">
              Reference IDs generated for every processed bill
            </div>
          </div>
        </div>
        <div className="grid-2">
          <div className="card">
            <div className="table-wrap">
              <table className="data-table" id="success-table" />
            </div>
          </div>
          <div className="card">
            <div className="card-title">Batch receipt</div>
            <table className="data-table">
              <tbody>
                <tr>
                  <td>Batch ID</td>
                  <td className="tright mono" id="succ-batch-id">
                    —
                  </td>
                </tr>
                <tr>
                  <td>Total paid</td>
                  <td className="tright mono" id="succ-total">
                    ₹0
                  </td>
                </tr>
                <tr>
                  <td>Successful</td>
                  <td
                    className="tright mono"
                    id="succ-ok"
                    style={{ color: "var(--green)" }}
                  >
                    0
                  </td>
                </tr>
                <tr>
                  <td>Failed</td>
                  <td
                    className="tright mono"
                    id="succ-fail"
                    style={{ color: "var(--red)" }}
                  >
                    0
                  </td>
                </tr>
              </tbody>
            </table>
            <button
              className="btn btn-ghost"
              style={{ width: "100%", justifyContent: "center", marginTop: 14 }}
              onclick="showToast('Receipt PDF downloaded')"
            >
              Download receipt
            </button>
            <button
              className="btn btn-primary"
              style={{ width: "100%", justifyContent: "center", marginTop: 10 }}
              onclick="go(null,'screen-dashboard')"
            >
              Back to dashboard
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
